import { HostListener, Input } from '@angular/core';
import { get, isFunction } from 'lodash-es';
import { ICol, IRow } from '../table.type';
import { hasKey, propGetter, valueGetter } from '../utils';

export class ColBase {
  @Input() row: IRow;
  @Input() col: ICol;
  @Input() index: number;
  @Input() configVersion = new Date().toTimeString();

  @HostListener('click') onClick() {
    if (this.col.onClick && isFunction(this.col.onClick)) {
      this.col.onClick(this.row, this.index);
    }
  }

  get value() {
    return valueGetter(this.row, this.col, this.index);
  }

  get tooltip() {
    const tooltip = get(this.col, 'tooltip');
    if (!hasKey(this.col, 'tooltip') || tooltip === true) {
      return this.value;
    }
    return propGetter(this.row, this.col, this.index, tooltip);
  }

  get innerStyle() {
    let _style: Partial<CSSStyleDeclaration> = {};
    if (get(this.col, 'ellipsis')) {
      const maxWidth = get(this.col, 'maxWidth', '');
      _style = {
        display: 'inline-block',
        maxWidth: maxWidth ? maxWidth : '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        verticalAlign: 'middle',
        whiteSpace: 'nowrap'
      };
    }
    return _style;
  }

  get outerStyle(): Partial<CSSStyleDeclaration> {
    return {
      display: 'inline-block',
      width: '100%'
    };
  }
}
